<template>
    <div class="main d-flex justify-content-center">
        <ProductsFilter :filtered="filteredProducts.length" :tags-available="tagsAvailable"
                        :conditions-available="conditionsAvailable" :types-available="typesAvailable"/>
        <div class="content">
            <div class="grid-header">
                <h4>Shop for bikes, electric bikes and electric scooters</h4>
            </div>
            <div v-if="filteredProducts.length" class="row product-grid-container">
                <div v-for="product in filteredProducts" :key="product.id" class="col-md-12 col-lg-6 col-xl-4 p-0">
                    <ProductSaleCard
                        :product="product"
                        :page-slug="getPageSlugByLayout('specifications')"/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ProductSaleCard from "../components/cards/ProductSaleCard";
import ProductsFilter from "../components/blocks/ProductsFilter";
import {mapActions, mapGetters} from "vuex";
import PageLayoutContentMixin from "../../mixins/ContentMixin";

const electricScooter = 'Electric Scooter';

export default {
    name: "BikesForSale",
    components: {ProductsFilter, ProductSaleCard},
    mixins: [PageLayoutContentMixin],
    computed: {
        ...mapGetters('app', ['products']),
        ...mapGetters('filter', ['productPriceRange', 'keyword', 'productTags', 'productTypes', 'productConditions', 'productEScooter']),
        tagsAvailable: function () {
            return [...new Set(Array.prototype.concat.apply([], this.products.filter(product => (product.meta.keywords?.length)).map(product => product.meta.keywords)))];
        },
        typesAvailable: function () {
            return [...new Set(this.products.filter(product => product.type !== undefined && product.type).map(product => {

                if (this.productEScooter.includes(product.type.toLocaleLowerCase())) {
                    return electricScooter;
                }

                return product.type;
            }))].sort();
        },
        conditionsAvailable: function () {
            return [...new Set(this.products.filter(product => product.condition !== undefined && product.condition).map(product => product.condition))].sort();
        },
        filteredProducts: function () {

            // By price range
            let filteredProducts = this.products.filter((product) => (product.price >= this.productPriceRange[0]) && (product.price <= this.productPriceRange[1]));

            // By tags/brand
            if (this.productTags.length > 0) {
                filteredProducts = filteredProducts.filter((product) => {
                    if (product.meta.keywords !== undefined && product.meta.keywords?.length > 0 && product.meta.keywords.filter(tag => this.productTags.includes(tag)).length > 0) {
                        return product;
                    }
                })
            }

            // By type
            if (this.productTypes.length > 0) {
                let productTypes = [...this.productTypes];
                if( productTypes.includes(electricScooter)) {
                    productTypes = [...productTypes, ...this.productEScooter]
                }
                filteredProducts = filteredProducts.filter(product => product.type !== undefined && (productTypes.includes(product.type) || productTypes.includes(product.type.toLocaleLowerCase() )))
            }

            // By condition
            if (this.productConditions.length > 0) {
                filteredProducts = filteredProducts.filter(product => product.condition !== undefined && this.productConditions.includes(product.condition))
            }

            // By Keyword
            if (this.keyword) {
                filteredProducts = filteredProducts.filter((product) => {
                    // const isType = product.type !== undefined && product.type ? product.type.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 : false;
                    // const isMetaTitle = product.meta !== undefined && product.meta.title !== undefined && product.meta.title ? product.meta.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 : false;
                    // const isMetaDescription = product.meta !== undefined && product.meta.description !== undefined && product.meta.description ? product.meta.description.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 : false;
                    // const isMetaKeywords = product.meta !== undefined && product.meta.keywords !== undefined && product.meta.keywords ? product.meta.keywords.join(', ').toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 : false;

                    return product.meta !== undefined && product.meta.title !== undefined && product.meta.title ? product.meta.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 : false;
                });
            }

            return filteredProducts.sort((a, b) => (b.discounted_price ?? b.price) - (a.discounted_price ?? a.price));
        }

    },
    methods: {
        ...mapActions('app', ['fetchProducts'])
    },
    beforeMount() {
        this.fetchProducts();
    }
}
</script>

<style scoped>

</style>
